import React from 'react';

import moment from 'moment';

export const formFields = {


  ro: {
    key: 'ro',
    label: 'RO ',
    placeholder: '',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'text',
  },
  roStatus: {
    key: 'roStatus',
    label: 'Status ',
    placeholder: '',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'text',
  },
}

export const optionsListHeader = {
  columns: [
    { id: 1, name: 's.no', label: 'S.No.', sortable: false, type: 'number', expand: true, },
    { id: 2, name: 'campaignName', label: 'Campaign Name', sortable: true, type: 'string',component: (row) => <div title={row.campaignName}>{row.campaignName.length > 28 ? `${row.campaignName.slice(0,28)} ...`: row.campaignName }</div> },
    { id: 3, name: 'model', label: 'Margin Model', sortable: true, type: 'string', component: (row) =>row.model == 'cpc' ? <span>CPC</span>: 'CPM'},
    { id: 4, name: 'type', label: ' Margin Type', sortable: true, type: 'string', component: (row) =>row.type == "fixedvalue" ? <span>Fixed Value</span>: '%Value' },
    { id: 5, name: 'value', label: 'Margin Value  ', sortable: true, type: 'number'},
   
  ],
  // keyCol: 'ioNo',
  actions: [{
    type: 'edit',
    text: '',
    icon: 'mdi mdi-pencil',
    tooltip: 'Edit'
  },
  ],
  // recActive: true,
  // status: {
  //   key: 'rec_active',
  //   active: '1',
  //   activeIcon: 'mdi mdi-checkbox-marked',
  //   inActiveIcon: 'mdi mdi-close-box',
  //   confirmation: true,
  //   activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
  //   inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
  // },
  actionsThead: true,
  sortable: true,
  dateType: true,
  defaultSortParams: {
    // sortBy: 'date',
    // sortOrder: 'asc'
  },
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  }
};

export const status = [
  {}
]